import {importProvidersFrom} from '@angular/core';
import {Route} from '@angular/router';
import {PATH_ADMIN} from '@evencel/models';
import {NgxsModule} from '@ngxs/store';
import {appGuard, formValidationGuard} from './app.guard';
import {Page404Component} from './modules/page-404/page-404.component';
import {AdminState, NotificationState} from './states';

export const appRoutes: Route[] = [
    {
        path: '',
        loadChildren: () => import('./modules/login/login.routes').then(r => r.loginRoutes),
    },
    {
        path: '401',
        loadComponent: () => import('./modules/page-401/page-401.component').then(r => r.Page401Component),
    },
    {
        path: PATH_ADMIN,
        canActivate: [appGuard],
        canActivateChild: [formValidationGuard],
        providers: [importProvidersFrom(NgxsModule.forFeature([AdminState, NotificationState]))],
        loadChildren: () => import('./modules/admin/admin.routes').then(r => r.adminRoutes),
    },
    {
        path: 'public',
        loadChildren: () => import('./modules/public/public.route').then(r => r.publicRoutes),
    },
    {path: '**', component: Page404Component},
];
